<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.firstName || 'First Name Missing' }} {{ userData.lastName || 'Last Name Missing' }}
            </p>
            <span class="user-status">{{ userData.fonction || 'Fonction Missing' }}  {{ userData.toll && userData.toll.name ? userData.toll.name : '' }}</span>
                                

          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            class="badge-minimal"
            badge-variant="success"
          >
            {{ userInitials }}
          </b-avatar>
        </template>

        <!-- <b-dropdown-divider /> -->

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Déconnexion</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>
<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { isUserLoggedIn } from '@/auth/utils';
import {api} from '@/auth/auth.js'; // Importez votre instance axios configurée
import { menuItems } from "@/navigation/vertical";
import { getJsonFromStorage } from "@/util/storageUtils"; // Importer la fonction pour récupérer les données du stockage

// BDropdownDivider
export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    // BDropdownDivider,
    BAvatar,
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userData: {
        firstName: '',
        lastName: '',
        fonction: '',
      },
    }
  },
  created() {
    if (isUserLoggedIn()) {
      const storedUserData = getJsonFromStorage('userData');
      if (storedUserData) {
        this.userData = storedUserData;
        
      }
    } else {
      this.$router.push({ name: 'login' });
    }
  },
  computed: {
    userInitials() {
      const { firstName, lastName } = this.userData;
      const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
      const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
      return `${firstInitial}${lastInitial}`;
    }
  },
  methods: {
    // logout() {
    //   localStorage.removeItem('userData');
    //   localStorage.removeItem('token');
    //   this.$router.push({ name: 'login' }).catch(err => {
    //     if (err.name !== 'NavigationDuplicated') {
    //       console.error(err);
    //     }
    //   });
    // }
     logout() {
  const token = localStorage.getItem("token");
  if (token && this.$router.currentRoute.path !== "/login") {
    this.$store.dispatch('user/logoutComplet');
  }
}

    
   
  },
}
</script>
